import Reveal from './ui/Reveal';

export default function FounderStory() {
  return (
    <section id="story">
      <div className="wrap">
        <div className="split">
          <Reveal>
            <span className="eyebrow">The founder&rsquo;s story</span>
            <h2 className="h-sec">The next step in your LNG career starts here.</h2>
            <p className="mt-m">
              I had read the books and studied the technical material. I was confident. Then I{' '}
              <b>failed an interview for a Third Officer position</b>.
            </p>
            <p>
              I studied harder — and failed again, this time for Chief Mate. The problem, I
              realised, wasn&rsquo;t a lack of information. It was a lack of{' '}
              <b>structured understanding</b>.
            </p>
            <p>
              So I changed how I learned: not memorising what happens onboard, but understanding{' '}
              <b>why</b> it happens and how every system connects. I passed my Chief Mate interview,
              then passed my <b>LNG Master interview on the first attempt</b>.
            </p>
            <p>
              I founded LNG School so other professionals never have to learn that lesson the hard
              way.
            </p>
          </Reveal>

          <Reveal as="figure" className="split-media media fit" delay={1}>
            <img
              className="media-img fill"
              src="/founder-mustapha.jpg"
              width="552"
              height="720"
              loading="lazy"
              decoding="async"
              alt="Captain Mustapha Zehhaf, founder of LNG School, in Master's uniform"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
